/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  position: relative;
  display: block
}

.container {
  text-align: start
}

.dropdown-title {
  margin-block-end: -1px;
  display: block;
  cursor: default;
  overflow-wrap: break-word;
  border-width: 0px;
  border-block-end-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-3);
  font-weight: var(--calcite-font-weight-bold);
  color: var(--calcite-color-text-2)
}

.dropdown-separator {
  display: block;
  block-size: 1px;
  background-color: var(--calcite-color-border-3)
}

:host([scale=s]) {
  font-size: var(--calcite-font-size--2);
  line-height: 1rem
}
:host([scale=s]) .dropdown-title {
  padding: 0.5rem
}

:host([scale=m]) {
  font-size: var(--calcite-font-size--1);
  line-height: 1rem
}
:host([scale=m]) .dropdown-title {
  padding: 0.75rem
}

:host([scale=l]) {
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem
}
:host([scale=l]) .dropdown-title {
  padding: 1rem
}

:host([hidden]) {
  display: none
}

[hidden] {
  display: none
}